import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectAllResults = (state: RootState) =>
	state?.results?.allResults;
